module.exports = __webpack_public_path__ + "png/quick-registration-coin-4.png?1f10ec5a39c8c2b1144de61eb289679c";